import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import SingleDemandDeviceDisplay from "./singleDemandDeviceDisplay"
import DataLoadError from "../../components/fallback/dataLoadError"
import SingleDeviceSkeleton from "../../components/loading/skeletons/singleDeviceSkeleton"
import AppPaper from "../../components/surfaces/appPaper"
import { Datasets } from "../../constants/enums"
import useMultiFetcherGetDevice from "../../services/middleware/hooks/useMultiFetcherGetDevice"

interface IDemandUrlParams {
    deviceId: string
    dataset: Datasets
}

/**
 * Webpage showing single demand device summary page. Handles API and
 * asynchronous logic and passes it to display component. Relies on `deviceId`
 * url parameter.
 */
const SingleDemandDevice = (): ReactElement => {
    const { deviceId, dataset } = useParams<
        keyof IDemandUrlParams
    >() as IDemandUrlParams
    const { data, isLoading, isError, mutate, isValidating } =
        useMultiFetcherGetDevice(deviceId, dataset)

    if (isLoading && !data) {
        return <SingleDeviceSkeleton />
    }
    if (isError) {
        return (
            <AppPaper>
                <DataLoadError />
            </AppPaper>
        )
    }
    if (!data) {
        return (
            <AppPaper>
                <h1>No data</h1>
            </AppPaper>
        )
    }
    return (
        <SingleDemandDeviceDisplay
            data={data}
            mutate={mutate}
            dataset={dataset}
            isLoading={isLoading}
            isValidating={isValidating}
        />
    )
}

export default SingleDemandDevice
